interface MaterialPercentage {
  percentage: number;
}

export function materialPercentageTotal(components: MaterialPercentage[]) {
  return components.reduce(
    (total, component) => total + component.percentage,
    0,
  );
}

export function hasValidMaterialPercentages(components: MaterialPercentage[]) {
  return (
    components.length === 0 ||
    (components.length >= 2 &&
      components.every(
        ({ percentage }) =>
          Number.isFinite(percentage) &&
          percentage > 0 &&
          percentage <= 100 &&
          Math.abs(percentage * 100 - Math.round(percentage * 100)) < 0.000001,
      ) &&
      Math.abs(materialPercentageTotal(components) - 100) < 0.000001)
  );
}
